import '@abbiamo/ui/styles';
import './theme/tailwind.css';
import './theme/easeui-theme.css';
import './theme/portal-ease.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider, ToastProvider, Toaster } from '@abbiamo/ui';
import { App } from './app/app';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <React.StrictMode>
    <ThemeProvider defaultTheme="system">
      <ToastProvider>
        <App />
        <Toaster position="top-right" />
      </ToastProvider>
    </ThemeProvider>
  </React.StrictMode>,
);
